import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cardEnabled: 'Your new card is now enabled',
    cardProductType: {
      PHYSICAL: 'Physical card',
      VIRTUAL: 'Virtual permanent card',
      VIRTUAL_BUDGET: 'Virtual budget card',
      VIRTUAL_TEMPORARY: 'Virtual temporary card',
    },
    description: '···· {pan} • {cardProductType}',
    limitsDescription: '{amount} of {maxAmount}',
  },
  fr: {
    cardEnabled: 'Votre nouvelle carte est maintenant active',
    cardProductType: {
      PHYSICAL: 'Carte physique',
      VIRTUAL: 'Carte virtuelle permanente',
      VIRTUAL_BUDGET: 'Carte virtuelle à budget',
      VIRTUAL_TEMPORARY: 'Carte virtuelle éphémère',
    },
    description: '···· {pan} • {cardProductType}',
    limitsDescription: '{amount} sur {maxAmount}',
  },
} as const);

export default locales;
